import { withInstall } from '@vuemap/vue-amap-util'
import ControlBar from './ControlBar.vue'

export const ElAmapControlControlBar = withInstall(ControlBar)
export default ElAmapControlControlBar
